import { graphql } from '../../gql';

export default graphql(`
    mutation verifyUser($password: String!, $token: String!) {
        verifyUser(input: { password: $password, token: $token }) {
            token
        }
    }
`);
